<template>
  <div style="padding: 0 15px;" @click="toggleClick">
    <svg
      :class="{'is-active':isActive}"
      class="hamburger"
      :style="{backgroundColor:this.$root.colorController}"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
    >
<!-- :style="{backgroundColor:this.$root.colorCon}" -->

      <path d="M161.51 225.04h128.02v63.92H161.51zM352.33 225.04h512.42v63.92H352.33zM161.51 481.96h128.02v63.92H161.51zM352.33 481.96h512.42v63.92H352.33zM161.51 736.76h128.02v63.92H161.51zM352.33 736.76h512.42v63.92H352.33z" fill='#000'/>

    </svg>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleClick() {
      this.$emit('toggleClick')
    }
  }
}
</script>

<style scoped>
.hamburger {
  display: inline-block;
  vertical-align: middle;
  width: 30px;
  height: 30px;

}

.hamburger.is-active {
  transform: rotate(180deg);
}
</style>
